<template>
    <div>
        <v-container>
            <v-row justify-space-between>
                <v-container px-0 pb-0>
                    <v-row justify-space-between>
                        <v-col>
                            <v-card class="pa-2 mr-2" flat height="100%">
                                <HostsView />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
                <v-container px-0 pb-0>
                    <v-row justify-space-between>
                        <v-col>
                            <v-card class="pa-2 mr-2" flat height="100%">
                                <Transactions />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
        </v-container>
    </div>
</template>
<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import HostsView from "@/components/HostsView";
    import Transactions from "@/components/Transactions";
    import {
        LOAD_HOSTS,
        LOAD_TRANSACTIONS,
    } from "@/store/_actiontypes";

    export default {
        components: { HostsView, Transactions },
        computed: {
            ...mapState({
                user: (state) => state.account.user,
            }),
        },
        data() {
            return {
                loading: false,
                dateMenu: false,
                reloadTimer: null,
            };
        },

        mounted() {
          this.startAutoReload();
        },

        beforeDestroy() {
            clearInterval(this.reloadTimer);
        },
        methods: {
            startAutoReload() {
                // run once immediately
                //this.reloadData();

                // run every 10 seconds
                //    this.reloadTimer = setInterval(() => {
                //        this.reloadData();
                //    }, 10000);
            },

            reloadData() {
                console.log("Parent refreshing…");
                this.$store.dispatch(`hosts/${LOAD_HOSTS}`);
                this.$store.dispatch(`transactions/${LOAD_TRANSACTIONS}`);
            }
        }
    };
</script>

<style scoped></style>
